import React, { useState, useEffect } from 'react';
import { apiClient } from '../services/api';
import './ProgressPage.css';

export const ProgressPage: React.FC = () => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const response = await apiClient.getStats();
      setStats(response.data);
    } catch (error) {
      console.error('Failed to load stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !stats) {
    return (
      <div className="page-container progress-page">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <p>Загрузка статистики...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container progress-page">
      <div className="page-header">
        <h1 className="page-title">Прогресс</h1>
        <p className="page-subtitle">Ваша статистика и достижения</p>
      </div>

      <div className="stats-overview">
        <div className="stat-cards-grid">
          <div className="stat-card-small">
            <div className="stat-icon-small">🌅</div>
            <div className="stat-value">{stats.streakDays}</div>
            <div className="stat-label-small">Дней подряд</div>
          </div>
          <div className="stat-card-small">
            <div className="stat-icon-small">📖</div>
            <div className="stat-value">{stats.journalEntries}</div>
            <div className="stat-label-small">Записей</div>
          </div>
          <div className="stat-card-small">
            <div className="stat-icon-small">✓</div>
            <div className="stat-value">{stats.tasksCompleted}</div>
            <div className="stat-label-small">Заданий</div>
          </div>
        </div>
      </div>

      <div className="charts-section">
        <div className="chart-container">
          <h2 className="section-title">Активность за неделю</h2>
          <div className="bar-chart">
            {stats.weeklyActivity.map((item: any, index: number) => {
              const maxValue = Math.max(...stats.weeklyActivity.map((d: any) => d.value));
              const height = (item.value / maxValue) * 100;
              return (
                <div key={index} className="bar-item">
                  <div className="bar-wrapper">
                    <div 
                      className="bar" 
                      style={{ height: `${height}%` }}
                    >
                      <span className="bar-value">{item.value}</span>
                    </div>
                  </div>
                  <div className="bar-label">{item.day}</div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="chart-container">
          <h2 className="section-title">Динамика настроения</h2>
          <div className="line-chart">
            <svg viewBox="0 0 300 150" className="line-chart-svg">
              {/* Grid lines */}
              <line x1="0" y1="30" x2="300" y2="30" stroke="rgba(196, 154, 108, 0.2)" strokeWidth="1" />
              <line x1="0" y1="60" x2="300" y2="60" stroke="rgba(196, 154, 108, 0.2)" strokeWidth="1" />
              <line x1="0" y1="90" x2="300" y2="90" stroke="rgba(196, 154, 108, 0.2)" strokeWidth="1" />
              <line x1="0" y1="120" x2="300" y2="120" stroke="rgba(196, 154, 108, 0.2)" strokeWidth="1" />
              
              {/* Line path */}
              <polyline
                fill="none"
                stroke="#D4735E"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                points={stats.moodTrend.map((item: any, index: number) => {
                  const x = (index / (stats.moodTrend.length - 1)) * 280 + 10;
                  const y = 130 - ((item.mood - 1) / 4) * 100;
                  return `${x},${y}`;
                }).join(' ')}
              />
              
              {/* Data points */}
              {stats.moodTrend.map((item: any, index: number) => {
                const x = (index / (stats.moodTrend.length - 1)) * 280 + 10;
                const y = 130 - ((item.mood - 1) / 4) * 100;
                return (
                  <circle
                    key={index}
                    cx={x}
                    cy={y}
                    r="4"
                    fill="#D4735E"
                    stroke="#ffffff"
                    strokeWidth="2"
                  />
                );
              })}
            </svg>
            <div className="line-chart-labels">
              {stats.moodTrend.map((item: any, index: number) => (
                <div key={index} className="chart-label">
                  {item.date}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

